import React from "react"
import "./ContactMessageBanner.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@fortawesome/free-solid-svg-icons"

interface ContactMessageBannerProps {
    error: boolean
    name: string
    message: string
    email: string
    close: React.Dispatch<React.SetStateAction<boolean>>
}

function creatEmailString(name: string, message: string, email: string) {
    let emailSubject = encodeURIComponent(`Trisha Somers Coaching - ${name}`)
    let emailMessageString = `Hello Trisha,\n\n${message}\n\nYou can contact me at ${email}\n\nThank you,\n${name}`
    let emailString = `mailto:trisha@trishasomers.com?subject=${emailSubject}&body=${encodeURIComponent(emailMessageString)}`

    return emailString
}

function ContactMessageBanner({ error, name, message, email, close }: ContactMessageBannerProps){


    return (
        <div className={`contact-banner ${error ? "error": "success"}`}>
            {error === true ? (
                <div className="contact-banner-message">
                    <h3>Something went wrong</h3>
                    <p>Message cannot be sent at this time Feel free to <a href={creatEmailString(name, message, email)} target='_blank' rel='noreferrer'>email me</a> directly.</p>
                </div>
            ) : (
                <div className="contact-banner-message">
                    <h3>Success</h3>
                    <p>Your message was sent</p>
                </div>
            )}
            <FontAwesomeIcon icon={faXmark} className='contact-banner-exit fa-xl'onClick={() => { close(false) }}/>
        </div>
    )
}

export default ContactMessageBanner